import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoEsquemaEditarComponent {
  data
  esquemaId
  catalogos
  guardando = false
  guardado = false
  idProyecto
  onClose

  constructor (ViaticosProyectoEsquemasService) {
    this.ViaticosProyectoEsquemasService = ViaticosProyectoEsquemasService
  }

  $onInit () {
    this.data = {
      esquema_id: this.data.esquema_id ? this.data.esquema_id : undefined,
      esquema_asimilado_id: this.data.esquema_asimilado_id ? this.data.esquema_asimilado_id : undefined,
    }
  }

  guardar () {
    this.guardando = true
    return this.ViaticosProyectoEsquemasService.post(this.idProyecto, this.data)
      .then(({data}) => {
        this.data = data
        this.modificado = true
        this.guardando = false
      })
  }

  eliminar () {
    this.guardando = true
    return this.ViaticosProyectoEsquemasService.delete(this.idProyecto)
      .then(({data}) => {
        this.data = {
          esquema_id: null,
          esquema_asimilado_id: null,
        }
        this.modificado = true
        this.guardando = false
      })
  }

  cerrar () {
    this.onClose({$event: {detail: this.data}})
  }
}

module.component('viaticosConfiguracionProyectoEsquemaEditar', {
  controller: ViaticosConfiguracionProyectoEsquemaEditarComponent,
  template,
  bindings: {
    data: '<',
    esquemaId: '<',
    catalogos: '<',
    idProyecto: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/esquema/editar/component.js